import type { Entity } from '@backstage/catalog-model';

export function shouldShowApiOverview(entity: Entity): boolean {
  const type =
    typeof entity.spec?.type === 'string' ? entity.spec.type.toLowerCase() : '';
  return (
    entity.kind.toLowerCase() !== 'api' ||
    !['openapi', 'asyncapi'].includes(type)
  );
}
